module.exports = __webpack_public_path__ + "static/ceremorphosis-ce0636e2aaa4eb4dd244aff6e5dbcd20.jpg";